import React, { useEffect, useState } from 'react';
import {Button, Card, CMFPasswordInput, CMFTextInput, CustomForm} from '@boschung/common-react-components';
import "./login-page.css"
import BoschungLogo from '../../images/boschung-logo-black.png';
import {Col, Row} from 'react-flexbox-grid';
import Loader from "../loader/Loader";
import {
    authenticate,
    doRedirect, getAzureClientId, getAzureScopes, getAzureTenantId,
    hasLoggedOut, isAzureEnabled,
    refreshAuthentication
} from "../../utils/authentication";
import {getRefreshToken, invalidateRefreshToken, saveRedirectUri} from "../../utils/storage";
import {
    AZURE_ACCESS_PARAMETER, getAzureAccessParam,
    getRedirectUriParam,
    hasParameter,
    REDIRECT_QUERY_PARAMETER_KEY
} from "../../utils/queryparam";
import AzureLogin from "../azure/AzureLogin";
import Divider from "../divider/Divider";
import { FormattedMessage } from 'react-intl';

const LoginPage = () => {
    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [loading, setLoading] = useState(false);
    const [isInError, setIsInError] = useState(false);
    const [refreshToken, setRefreshToken] = useState(getRefreshToken());

    useEffect(() => {
        if (hasParameter(AZURE_ACCESS_PARAMETER)) doRedirect(getAzureAccessParam(), null);
        if (hasParameter(REDIRECT_QUERY_PARAMETER_KEY)) saveRedirectUri(getRedirectUriParam());

        if (refreshToken !== null) {
            refreshAuthentication(refreshToken)
                .catch(() => {
                    invalidateRefreshToken();
                    setRefreshToken(null);
                })
        }
    });

    const onSubmit = () => {
        setLoading(true)
        authenticate(username, password)
            .finally(() => setLoading(false))
            .catch(() => setIsInError(true));
    }

    const onUsernameChange = (e) => setUsername(e.target.value.trim());
    const onPasswordChange = (e) => setPassword(e.target.value);

    const loginForm = () => {
        return (
            <CustomForm
                formikProps={{
                    onSubmit,
                    initialValues: {username: '', password: ''}
                }}
            >
                <Row>
                    <Col sm={12}>
                        <CMFTextInput
                            id="username"
                            name="username"
                            label={<FormattedMessage id="username" />}
                            onChange={onUsernameChange}
                            value={username}
                        />
                    </Col>
                    <Col sm={12}>
                        <CMFPasswordInput
                            id="password"
                            name="password"
                            label={<FormattedMessage id="password" />}
                            onChange={onPasswordChange}
                            value={password}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <div className="signin-form-submit-container">
                            <Button
                                className="auto-margin signin-form-submit-button"
                                buttonStyle="primary"
                                buttonSize="sm"
                                type="submit"
                                text={<FormattedMessage id="signIn" />}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <div className="signin-form__result">
                            {loading && <Loader />}
                            {isInError && <span className="signin-form-result"><FormattedMessage id="incorrectUsernameOrPassword" /></span>}
                        </div>
                    </Col>
                </Row>
            </CustomForm>
        )
    }

    return (
        <>
            {// TODO: handle user feedback when redirected from logout. Missing Thibaut's input on the design
                hasLoggedOut() && <></>
                /*<div className="login-logout-info">
                    <span>Logged out successfully.</span>
                </div>*/
            }
            {refreshToken === null &&
                <Card className="login-container">
                    <div className="login-container-header">
                        <img src={BoschungLogo} className="login-container-logo" alt=""/>
                        {loginForm()}
                        {isAzureEnabled() &&
                            <>
                                <Divider dividerText={<FormattedMessage id="or" />} />
                                <AzureLogin
                                    clientId={getAzureClientId()}
                                    tenantId={getAzureTenantId()}
                                    scope={getAzureScopes()}
                                />
                            </>
                        }
                    </div>
                </Card>
            }
        </>
    )
}


export default LoginPage;
